const OFFICIALS = [
  { id: "authorizedPersons", title: "Authorized Person" },
  { id: "alternateDirectors", title: "Alternate Director" },
  { id: "directors", title: "Director" },
  { id: "directorShareholders", title: "Director Shareholder" },
  { id: "shareholders", title: "Shareholder" },
  { id: "jointShareholders", title: "Joint Shareholder" },
  { id: "beneficialOwners", title: "Beneficial Owner" },
  { id: "companySecretaries", title: "Company Secretary" },
  { id: "auditor", title: "Auditor" },
  { id: "administrator", title: "Administrator" },
];

const SHARECAPITALOPTIONS = [
  { id: "allotment", title: "Allotment of Shares" },
  { id: "shareTransfer", title: "Share Transfer" },
  { id: "shareTransmission", title: "Transmission of Shares" },
  { id: "shareSorfeiture", title: "Forfeiture of Shares" },
  { id: "shareSurrender", title: "Surrender of Shares" },
  { id: "shareConsolidation", title: "Shares Consolidation" },
  { id: "shareSubDivision", title: "Shares Sub-division" },
  { id: "shareBuyback", title: "Shares Buyback" },
  { id: "shareRedemption", title: "Shares Redemption" },
  {
    id: "nameChangeNotice",
    title: "Notice of Change of Name/Designation of a Class of Shares",
  },
  {
    id: "variationNotice",
    title: "Notice of Particulars of Variation of Class Rights of Shares",
  },
  { id: "capitalReduction", title: "Reduction of Share Capital" },
  { id: "shareTakeover", title: "Takeover Offer" },
];

const ALLOTMENTOPTIONS = [
  {
    id: "unallotted",
    title: "Companies with unallotted shares or existing authorization",
  },
  {
    id: "oneClass",
    title: "Private Company with only One (1) Class of Shares",
  },
  {
    id: "multipleClasses",
    title: "Private Company with more than One (1) Class of Shares, and all",
  },
  { id: "authorization", title: "Authorization" },
];

const CHANGE_TYPES = ["Appointment", "Change of Particulars", "Cessation"];

export { OFFICIALS, CHANGE_TYPES, SHARECAPITALOPTIONS, ALLOTMENTOPTIONS };
